import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { removeUserSession } from '../../utils/sessionManagement'
import LoadingPage from '../../components/Loading/LoadingPage'

const LogoutPage = () => {
  const history = useNavigate()

  useEffect(() => {
    // Appel de la fonction pour supprimer les informations de session
    removeUserSession()

    // Redirection vers la page de connexion
    history('/login')
  }, [history])

  // Afficher un message ou un indicateur de chargement pendant la déconnexion
  return <LoadingPage />
}

export default LogoutPage
